module.exports = __webpack_public_path__ + "static/media/Parking_solution_png.7c2e4adf.png";